import React, { forwardRef, useContext } from 'react'

import { Text } from '@hhgtech/hhg-components/mantine'
import { Box, SelectItem } from '@mantine/core'

import { CareHospital } from 'interfaces/types'

import { ClinicLocatorContext } from './context'
import useStyles from './index.styles'

export const ClinicSearchItem = forwardRef<
  HTMLDivElement,
  CareHospital & SelectItem
>(function _ClinicSearchItem({ id, name, address, ...props }, ref) {
  const { isMobile } = useContext(ClinicLocatorContext)
  const { classes } = useStyles({ useMobileLayout: isMobile })
  return (
    <Box className={classes.resultItem} ref={ref} key={id} {...props}>
      <Text size="s3" weight="semiBold">
        {name}
      </Text>
      <Text
        size="p4"
        sx={{
          display: '-webkit-box',
          '-webkit-line-clamp': '3',
          '-webkit-box-orient': 'vertical',
          overflow: 'hidden',
        }}
      >
        {address}
      </Text>
    </Box>
  )
})
